import { useContext } from "react";
import { ViewModeContext } from "./ViewModeProvider";

export const useViewMode = () => {
  const context = useContext(ViewModeContext);

  if (!context) {
    throw new Error(
      "You cannot use useViewMode outside ViewModeContext! Use ViewModeProvider for that."
    );
  }

  return context;
};
